<script lang="ts">
  import logoImage from "@/assets/logo.png"
</script>

<img src={logoImage} alt="Chorizo" class="size-8 rounded-md" />
<div class="ml-1 grid flex-1 text-left text-sm">
  <span class="mb-0.5 truncate leading-tight font-semibold"> Chorizo </span>
</div>
